var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFeatherImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.207,
    height: 12.207,
    viewBox: "0 0 12.207 12.207",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-image",
    "data-name": "Icon feather-image",
    transform: "translate(-4 -4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_700",
    "data-name": "Path 700",
    d: "M5.722,4.5h8.556A1.222,1.222,0,0,1,15.5,5.722v8.556A1.222,1.222,0,0,1,14.278,15.5H5.722A1.222,1.222,0,0,1,4.5,14.278V5.722A1.222,1.222,0,0,1,5.722,4.5Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_701",
    "data-name": "Path 701",
    d: "M12.333,11.417a.917.917,0,1,1-.917-.917A.917.917,0,0,1,12.333,11.417Z",
    transform: "translate(-3.556 -3.556)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_702",
    "data-name": "Path 702",
    d: "M17.278,18.056,14.222,15,7.5,21.722",
    transform: "translate(-1.778 -6.222)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFeatherImage);
export default __webpack_public_path__ + "static/media/Icon-feather-image.93263a69de9d463cc571e724d66174e9.svg";
export { ForwardRef as ReactComponent };